<template>
<div>
  <div class="menu" id="menu">
      <div class="content1">
        <div class="btn">
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li>
               <router-link :to="{path:'/speciesblast',query:{url:url,blastPort:blastPort}}">Blast</router-link>
            </li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  <div class="content">
    <div class="top">
      <div class="title"  v-html="title"></div>
       <div class="blast">
        <el-button size="mini" round>
         <!-- <a target="_blank" :href="url+':'+blastPort">BLAST</a>  -->
         <router-link :to="{path:'/speciesblast',query:{url:url,blastPort:blastPort}}">BLAST</router-link>
        </el-button>
      </div>
    </div>
    <div class="center">
       <img v-if="plant_name == '大麻'" src="../../assets/dama.jpg" />
        <img v-if="plant_name == '丹参'" src="../../assets/dansheng.jpg" />
        <img v-if="plant_name == '菊花脑'" src="../../assets/juhuanao.png" />
        <img
          v-if="plant_name == '黄花蒿'"
          src="../../assets/huanghuasong.jpg"
        />
        <img v-if="plant_name == '罂粟'" src="../../assets/yingshu.jpg" />
      <div class="search">
        <el-input
          v-model="searchValue"
          placeholder="Gene ID/Name/Function"
          class="input-with-select"
        >
          <el-button
            @click="btnSearch"
            slot="append"
            icon="el-icon-search"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="bottom">
      <div class="res">
        <div class="search_res">Search Result</div>
        <div class="msg">
          Your search condition is:<b>{{ searchValue }}</b> A total of
          {{ total }}Related messages are matched.
        </div>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in tableData" :key="index">
          <div class="title">
            <div>
              {{ item.id }}、<router-link
                :to="{
                  path: '/detail',
                  query: {
                    id: item.id,
                    version: version,
                    url:url,
                    blastPort:blastPort
                  },
                }"
                >{{ item.geneId }}</router-link
              >
            </div>
            <div class="sp">
              <router-link
                :to="{
                  path: '/Blast',
                  query: {
                    id: item.id,
                    blastPort:blastPort
                  },
                }"
                >B</router-link
              >
            </div>
          </div>
          <div class="content">
            <div>Gene Name:{{ item.geneName }}</div>
            <!-- <div>Genomes:{{item.geneName}}</div> -->
            <div>Description:{{ item.description }}</div>
          </div>
        </div>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchValue: "",
      tableData: [],
      version: "",
      keyword: "",
      latin_name:'',
      plant_name:'',
      url:"",
      blastPort:"",
      did:'',
      title:''
    };
  },
  created() {
     window.addEventListener("scroll", this.handleScroll); 
    let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Please login first!", "Notice", {
              confirmButtonText: "Confirm",
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
    
    let keyword = this.$route.query.value;
    let version = this.$route.query.version;
    let did = this.$route.query.did;
    //console.log(this.$route.query.did);
    let url = this.$route.query.url;
    let plant_name = this.$route.query.plant_name;
    let blastPort = this.$route.query.blastPort;
    if (keyword == "" || keyword == null || version == "" || version == null || did=="" || did==null) {
      this.$router.push("/");
    } else {
      this.searchValue = keyword;
      this.version = version;
      this.keyword = keyword;
      this.did = did;
       this.getbyid(did);
       this.url = url;
       this.plant_name=plant_name;
      this.blastPort = blastPort;
      this.getGeneList(keyword, this.pageNum, this.pageSize, version);
    }
  },
  methods: {
     handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
    
    getbyid(did){
        let that = this;
        let token=localStorage.getItem("authorization");
      axios
        .get("/bena/server/gooal/description/getbyid?id="+did,{
          headers: { Authorization: token },
        })
        .then(function (response) {
          ////console.log(response);
          if (response.data.code == 0) {
            //that.tableData = response.data.result;
            that.title=response.data.result.mainDes;
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
          //that.$message.error("失败!");
           that.$alert("Loading failed！" + error.response.data.message, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          //console.log(error);
        });
    },
    btnSearch() {
      if(this.searchValue=="" || this.searchValue==null){
         this.$alert("请输入GeneID/Name/Function！", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
      }else{
        this.getGeneList(
        this.searchValue,
        this.pageNum,
        this.pageSize,
        this.version
      );
      }
      
    },
    getGeneList(keyword, pageNum, pageSize, version) {
      let that = this;
      let token=localStorage.getItem("authorization");
      axios
        .get(
          "/bena/server/gooal/gene?keyword=" +
            keyword +
            "&pageNum=" +
            pageNum +
            "&pageSize=" +
            pageSize +
            "&version=" +
            version
       ,{
          headers: { Authorization: token },
        } )
        .then(function (response) {
          //console.log(response);
          that.blastPort= response.data.blastPort;
          that.tableData = response.data.maps;
          that.total = response.data.total;
        })
        .catch(function (error) {
          that.$message.error("该基因组没有Version!");
          //console.log(error);
        });
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getGeneList(this.keyword, this.pageNum, this.pageSize, this.version);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getGeneList(this.keyword, this.pageNum, this.pageSize, this.version);
    },
  },
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.content {
  width: 1200px;
  height: auto;
  margin: 0 auto 20px auto;
  border: 1px solid #eee;
}
.top {
  width: 1140px;
  height: 80px;
  line-height: 80px;
  padding: 0 30px;
  display: flex;
}
.top .title {
  flex: 1;
  color: seagreen;
}
.top .blast {
  width: 100px;
}
.top .blast .el-button.el-button--default.el-button--mini.is-round {
  background: seagreen;
  color: #fff;
}
.top .blast a{
  color: #fff;
  text-decoration: none;
}
.mglm {
  margin-left: 40px;
}
.center {
  border-bottom: 1px solid #eee;
  box-shadow: 1px 1px 1px #eee;
}
.center img {
  width: 1200px;
  height: 450px;
  border-radius: 8px 8px 0 0;
}
.center .search {
  width: 800px;
  height: 40px;
  /* border: 1px solid red; */
  padding: 20px 200px;
}
.center .search .el-button.el-button--default {
  background: seagreen;
  color: #fff;
  width: 100px;
  border-radius: 0px 5px 5px 0px;
  height: 40px;
}
.center .search >>> .el-input__inner {
  border-radius: 5px 0px 0px 5px;
}
.bottom {
  width: 1200px;
  height: auto;
  background: #fff;
}
.res {
  width: 100%;
  height: 50px;
  display: flex;
}
.res .search_res {
  text-align: center;
  line-height: 50px;
  background: seagreen;
  color: #fff;
  padding: 0px 20px;
}
.res .msg {
  flex: 1;
  padding: 0 0 0 40px;
  line-height: 50px;
  font-size: 12px;
}
.list {
  width: 100%;
  height: auto;
  margin: 20px 0;
  padding: 0 20px;
}
.list .item {
  width: 1130px;
  height: auto;
  border: 1px solid #eee;
  padding: 10px;
}
.list .item .title {
  display: flex;
  font-size: 14px;
  color: seagreen;
  line-height: 30px;
}
.list .item .title a {
  font-size: 14px;
  color: seagreen;
  line-height: 30px;
  text-decoration: none;
}
.list .item .title .sp {
  padding: 0px 10px;
  background: seagreen;
  color: #fff;
  border-radius: 3px;
  margin-left: 20px;
}
.list .item .title .sp a {
  color: #fff;
}
.list .content {
  border: none;
  font-size: 12px;
  color: #aaa;
  line-height: 25px;
  margin: 0;
}
.list .pagination {
  text-align: right;
  margin: 20px 40px 0 0;
}
.list >>> .pagination.el-pagination .el-pager .active {
  color: seagreen;
}
.list >>> .pagination.el-pagination .el-pager li:hover {
  color: seagreen;
}
</style>
